(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multimodal-cards"] && !Shopify.designMode) return;
  try {
    
  class MultimodalCardsCarousel extends HTMLElement {
    connectedCallback() {
      if (this.isConnectedReady) return;

      this.isConnectedReady = true;
      this.track = this.querySelector('[data-carousel-track]');
      this.cards = [...this.querySelectorAll('[data-carousel-card]')];
      this.previousButton = this.querySelector('[data-carousel-action="previous"]');
      this.nextButton = this.querySelector('[data-carousel-action="next"]');
      this.abortController = new AbortController();
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (this.track) {
        this.track.addEventListener('scroll', () => this.updateNavigation(), {
          passive: true,
          signal: this.abortController.signal,
        });
        this.track.addEventListener('keydown', (event) => this.onTrackKeydown(event), {
          signal: this.abortController.signal,
        });
      }

      this.addEventListener('click', (event) => this.onClick(event), {
        signal: this.abortController.signal,
      });
      this.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), {
        signal: this.abortController.signal,
      });

      this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
      if (this.track) this.resizeObserver.observe(this.track);

      this.preloadObserver = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.prepareVideos();
          this.preloadObserver.disconnect();
        },
        { rootMargin: '1000px 0px' }
      );
      this.preloadObserver.observe(this);

      this.videoObserver = new IntersectionObserver(
        (entries) => entries.forEach((entry) => this.updateVideoVisibility(entry)),
        { threshold: 0.55 }
      );

      this.cards.forEach((card) => {
        const video = card.querySelector('video');
        if (!video) return;
        this.videoObserver.observe(card);
        video.addEventListener('loadeddata', () => card.classList.add('is-video-ready'), {
          signal: this.abortController.signal,
        });
        video.addEventListener('play', () => this.updateVideoState(card, true), {
          signal: this.abortController.signal,
        });
        video.addEventListener('pause', () => this.updateVideoState(card, false), {
          signal: this.abortController.signal,
        });
      });

      this.updateNavigation();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      this.preloadObserver?.disconnect();
      this.videoObserver?.disconnect();
      this.isConnectedReady = false;
    }

    onClick(event) {
      const navigationButton = event.target.closest('[data-carousel-action]');
      if (navigationButton) {
        this.navigate(navigationButton.dataset.carouselAction === 'next' ? 1 : -1);
        return;
      }

      const videoButton = event.target.closest('[data-video-toggle]');
      if (!videoButton) return;

      const card = videoButton.closest('[data-carousel-card]');
      const video = card?.querySelector('video');
      if (!video) return;

      if (video.paused) {
        card.dataset.manualPaused = 'false';
        this.prepareVideo(video);
        video.play().catch(() => {});
      } else {
        card.dataset.manualPaused = 'true';
        video.pause();
      }
    }

    onTrackKeydown(event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      this.navigate(event.key === 'ArrowRight' ? 1 : -1);
    }

    onBlockSelect(event) {
      const card = this.querySelector(`[data-block-id="${event.detail.blockId}"]`);
      card?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    navigate(direction) {
      if (!this.track || !this.cards.length) return;

      const trackStyles = getComputedStyle(this.track);
      const gap = Number.parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
      const cardWidth = this.cards[0].getBoundingClientRect().width;
      const inlineDirection = trackStyles.direction === 'rtl' ? -1 : 1;

      this.track.scrollBy({
        left: direction * inlineDirection * (cardWidth + gap),
        behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
      });
    }

    updateNavigation() {
      if (!this.track) return;

      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      if (this.previousButton) this.previousButton.disabled = this.track.scrollLeft <= 2;
      if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 2;
    }

    prepareVideos() {
      this.querySelectorAll('video').forEach((video) => this.prepareVideo(video));
    }

    prepareVideo(video) {
      if (video.dataset.prepared === 'true') return;
      video.dataset.prepared = 'true';
      video.preload = 'metadata';
      video.load();
    }

    updateVideoVisibility(entry) {
      const card = entry.target;
      const video = card.querySelector('video');
      if (!video) return;

      const canAutoplay = card.dataset.autoplay === 'true' && card.dataset.manualPaused !== 'true';
      if (entry.isIntersecting && canAutoplay && !this.reducedMotion.matches) {
        this.prepareVideo(video);
        video.play().catch(() => {});
      } else if (!entry.isIntersecting && !video.paused) {
        video.pause();
      }
    }

    updateVideoState(card, isPlaying) {
      const button = card.querySelector('[data-video-toggle]');
      if (!button) return;

      card.classList.toggle('is-playing', isPlaying);
      button.setAttribute('aria-pressed', String(isPlaying));
      button.setAttribute('aria-label', isPlaying ? button.dataset.pauseLabel : button.dataset.playLabel);
    }
  }

  if (!customElements.get('multimodal-cards-carousel')) {
    customElements.define('multimodal-cards-carousel', MultimodalCardsCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
